import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

import Page from "@/components/Page";
import Loading from "@/components/Loading";
import Breadcrumbs from "@/components/Breadcrumbs";
import MainActions from "@/components/MainActions";
import VLFCard from "@/components/Card";
import VLFTextField from "@/components/Input/TextField";
import DataTable from "@/components/DataTable";
import StatusBadge from "@/components/StatusBadge";

import {UserAPI} from "@/api/user";

import AddIcon from "@mui/icons-material/Add";

import {ERROR_OPERATION} from "@/utils/constants";

// Stato dell'utenza: bloccata, in attesa di approvazione o attiva
const userStatus = (u) =>
	u.isLockedOut
		? {tone: "critical", label: "Bloccato"}
		: u.isApproved === false
			? {tone: "warning", label: "Da approvare"}
			: {tone: "good", label: "Attivo"};

function UsersPage(props) {
	const {handleNotification} = props;
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [users, setUsers] = useState([]);
	const [search, setSearch] = useState("");

	useEffect(() => {
		const getUsers = async () => {
			setLoading(true);
			try {
				setUsers((await UserAPI.list()) || []);
			} catch {
				handleNotification(ERROR_OPERATION, "error");
			} finally {
				setLoading(false);
			}
		};
		getUsers();
	}, []);

	const term = search.trim().toLowerCase();
	const visible = users.filter((u) =>
		[u.userName, u.firstName, u.lastName, u.email, u.roleName]
			.filter(Boolean)
			.join(" ")
			.toLowerCase()
			.includes(term),
	);

	const columns = [
		{
			key: "userName",
			label: "Utente",
			render: (u) => (
				<>
					<div className="fw-medium">{u.userName}</div>
					{(u.firstName || u.lastName) && (
						<div className="text-secondary small">
							{[u.firstName, u.lastName].filter(Boolean).join(" ")}
						</div>
					)}
				</>
			),
			sortable: true,
		},
		{key: "roleName", label: "Ruolo", sortable: true},
		{key: "email", label: "Email", render: (u) => u.email || "—"},
		{
			key: "status",
			label: "Stato",
			render: (u) => <StatusBadge {...userStatus(u)} />,
			sortValue: (u) => userStatus(u).label,
		},
	];

	return (
		<Page>
			<Loading visible={loading} />
			<Breadcrumbs
				current="Utenti"
				actions={
					<MainActions
						actions={[
							{
								icon: <AddIcon />,
								title: "Nuovo utente",
								onClick: () => navigate("/settings/users/new"),
							},
						]}
					/>
				}
			/>
			<VLFCard
				content={
					<>
						<VLFTextField
							placeholder="Cerca per nome, utente, email o ruolo"
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
						<DataTable
							columns={columns}
							rows={visible.map((u) => ({...u, id: u.userName}))}
							onRowClick={(u) => navigate("/settings/users/" + u.userName)}
							empty="Nessun utente."
						/>
					</>
				}
			/>
		</Page>
	);
}

export default UsersPage;
